<div class="mt-3 container-fluid animate__animated animate__slideInUp">
    <mat-card>
        <mat-card-title>Generar declaracion jurada 1887</mat-card-title>
    </mat-card>
    <br>
    <mat-card>
        <mat-card-content>
            <app-generarddjj></app-generarddjj>
        </mat-card-content>
    </mat-card>
</div>